import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AuthService } from 'src/app/core/services/auth.service'
import { UtilsService } from 'src/app/core/services/utils.service'
import { Constants } from 'src/app/core/constants/constants'
import { AlertsService } from 'src/app/core/services/alerts.service'
import { ActivatedRoute, Router } from '@angular/router'
import Swal from 'sweetalert2'
import { User } from 'src/app/core/models/user.model'
import { UsuarioService } from 'src/app/core/services/usuario.service'
import { ParametrosService } from 'src/app/core/services/parametros.service'
import { TransactionsService } from 'src/app/core/services/transactions.service'
import { PaisesConstants } from 'src/app/core/constants/paises'
import { PaymentService } from 'src/app/core/services/payment.service'

@Component({
  selector: 'app-pre-payment',
  templateUrl: './pre-payment.component.html',
  styleUrls: ['./pre-payment.component.scss'],
})
export class PrePaymentComponent implements OnInit {
  firstFormGroup: FormGroup
  secondFormGroup: FormGroup

  public activeOption = 'login'
  public showLogin = true
  public showRegister = false
  public showCompanyFields = false
  public usuario = null
  public verifyingLogin = false
  public loginForm = null
  public registerForm = null
  public listParams = null
  public rol = null
  public precio = null
  public returnUrl = null
  public paises = PaisesConstants.countries.sort((a, b) => {
    const nameA = a.name_es.toUpperCase()
    const nameB = b.name_es.toUpperCase()
    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    return 0
  })

  constructor(
    private fb: FormBuilder,
    private svUtils: UtilsService,
    private authService: AuthService,
    private alertsService: AlertsService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private svUsuario: UsuarioService,
    private svParams: ParametrosService,
    private svPayment: PaymentService,
  ) {}

  ngOnInit() {
    if (this.aRoute.snapshot.paramMap.get('precio')) {
      this.precio = atob(this.aRoute.snapshot.paramMap.get('precio'))
      this.returnUrl = atob(this.aRoute.snapshot.paramMap.get('return_url'))
    }

    this.getParameters()
    this.loginForm = this.fb.group({
      correo_usuario: [null, [Validators.required]],
      clave_usuario: [null, [Validators.required]],
    })

    this.registerForm = this.fb.group({
      id_parametro_rol: [null, [Validators.required]],
      nombres_usuario: [null, [Validators.required]],
      apellidos_usuario: [null, [Validators.required]],
      correo_usuario: [null, [Validators.required]],
      telefono_usuario: [null, [Validators.required]],
      pais_usuario: [null, [Validators.required]],
      fecha_de_nacimiento_usuario: [null, [Validators.required]],
      clave_usuario: [null, [Validators.required]],
      confirmar_clave_usuario: [null, [Validators.required]],
      checkPolitics: [null, [Validators.required]],
    })
  }

  getParameters() {
    this.svParams.getTypeParameters().subscribe((reps) => {
      reps['body']['data'].filter((data) => {
        if (data['nombre_tipo_parametro'] === 'TIPO ROL') {
          this.svParams
            .getParameters(data['id_tipo_parametro'])
            .subscribe((rp) => {
              this.listParams = rp['body']['data']
              this.listParams.filter((p) => {
                if (p['nombre_parametro'] == 'General') {
                  this.rol = p['id_parametro']
                }
              })
            })
        }
      })
    })
  }

  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser()
  }

  getSelection(selection) {
    if (selection == 'company') {
      this.showCompanyFields = true
      return
    }
    this.showCompanyFields = false
  }
  getOptionSeleted(option) {
    this.activeOption = option

    if (option == 'login') {
      this.showLogin = true
      this.showRegister = false
    }
    if (option == 'register') {
      this.showRegister = true
      this.showLogin = false
    }
  }

  loginUser(formValues) {
    this.verifyingLogin = true

    if (formValues['correo_usuario'] != null) {
      const request = {
        correo_usuario: formValues['correo_usuario'],
        clave_usuario: formValues['clave_usuario'],
      }

      this.authService.login(request).subscribe(
        (data) => {
          if (data.status == 'success') {
            localStorage.setItem(
              Constants.ls.user,
              btoa(JSON.stringify(data['result']['user_data'])),
            )
            localStorage.setItem(
              Constants.ls.at,
              btoa(JSON.stringify(data['result']['token'])),
            )

            setTimeout(() => {
              this.verifyingLogin = false
            }, 1000)
            // this.alertsService.showSnackBar('Bienvenido al sistema...', 3000);
            this.svPayment.goToPay(
              this.precio,
              `${this.returnUrl.replace(
                '/plans',
                '',
              )}/auth/confirmation-payment`,
            )

            this.verifyingLogin = false
          } else {
            Swal.fire('Error: Datos incorrectos', data.message, 'error')
          }
        },
        (err) => {
          this.verifyingLogin = false
          Swal.fire(
            'Error: Inicio de sesión',
            'Algo salió mal al intentar iniciar sesión, intentelo más tarde',
            'error',
          )
        },
      )
    } else {
      this.verifyingLogin = false
      Swal.fire(
        'Advertancia: ',
        'Por favor ingrese los datos de inicio de sesión',
        'warning',
      )
    }
  }
  registerUser(formValues) {
    if (formValues['clave_usuario'] !== formValues['confirmar_clave_usuario']) {
      Swal.fire('Advertancia: ', 'Las contraseñas no coinciden', 'warning')
      return
    }

    const request = {
      id_parametro_rol: this.rol,
      nombres_usuario: formValues['nombres_usuario'],
      apellidos_usuario: formValues['apellidos_usuario'],
      correo_usuario: formValues['correo_usuario'],
      telefono_usuario: formValues['telefono_usuario'],
      pais_usuario: formValues['pais_usuario'],
      fecha_de_nacimiento_usuario: formValues['fecha_de_nacimiento_usuario'],
      clave_usuario: formValues['clave_usuario'],
    }

    this.svUsuario.register(request).subscribe(
      (data) => {
        if (data.status == 'success') {
          this.alertsService.showSnackBar('Ya puedes iniciar sesión...', 3000)
          // this.router.navigate(['auth/confirmation-payment']);
        } else {
          Swal.fire('Crear cuenta', data['message'], 'warning')
        }
      },
      (err) => {
        Swal.fire(
          'Error al crear cuenta',
          'Algo salió mal al intentar iniciar sesión, intentelo más tarde',
          'error',
        )
      },
    )
  }
}
